/**
 * A partner-átjáró kezelő route-jai.
 *
 * Külön fájlban, hogy a pakk egyben mozogjon: a `router/routes.js` egyetlen sorral fűzi be.
 * A partner AZONOSÍTÓJA (neve) az útvonalban van — nem a fiók azonosítója, mert fiók nem
 * minden partnerhez tartozik.
 */
export default [
    {
        path: "apihub",
        name: "apihub",
        component: () => import("../views/helpers/grouper/grouper.vue"),
        meta: {
            translate: (t) => t("menu_points.system_apihub").ucFirst(),
            type: "global",
        },
        redirect: {name: "apihub-overview"},
        children: [
            {
                path: "",
                name: "apihub-overview",
                component: () => import("./views/overview.vue"),
                meta: {
                    authRequired: true,
                    translate: (t) => t("menu_points.system_apihub").ucFirst(),
                },
            },
            {
                path: ":partner([a-z0-9_-]+)",
                name: "apihub-partner",
                props: true,
                component: () => import("./views/partner.vue"),
                meta: {
                    authRequired: true,
                    translate: (t) => t("menu_points.system_apihub").ucFirst(),
                },
            },
        ],
    },
];
